import type { LevelOpenFullDoors } from "building-types/doors/levelOpenFullDoors";
import type { RoomConnection } from "building-types/rooms/roomTraversalTypes";
import { RoomConnectionType } from "building-types/rooms/roomTraversalTypes";
import type { Table } from "common/data/table";
import init2DArray from "common/utils/init2DArray";

/**
 * Forms RoomConnections from the OPEN_FULL doors on the given level
 */
export function collectRoomConnectionsOnLevel({
  openFullDoors,
  levelId,
  roomsByLevel,
  roomLevelIndices,
}: {
  openFullDoors: LevelOpenFullDoors;
  levelId: string;
  roomsByLevel: Table<string[]>;
  roomLevelIndices: Table<number>;
}): RoomConnection[][] {
  const levelOpenFullDoors: LevelOpenFullDoors = openFullDoors[levelId] || {};
  const roomConnections: RoomConnection[][] = init2DArray(roomsByLevel[levelId].length);

  for (const halfEdge in levelOpenFullDoors) {
    const { startRoomId, endRoomId } = levelOpenFullDoors[halfEdge];
    const frontRoomIndexOnLevel = roomLevelIndices[startRoomId];

    if (endRoomId) {
      const backRoomIndexOnLevel = roomLevelIndices[endRoomId];

      roomConnections[frontRoomIndexOnLevel].push({
        roomIndexOnLevel: backRoomIndexOnLevel,
        connectionType: RoomConnectionType.OPEN,
        halfEdge: +halfEdge,
      });
      roomConnections[backRoomIndexOnLevel].push({
        roomIndexOnLevel: frontRoomIndexOnLevel,
        connectionType: RoomConnectionType.OPEN,
        halfEdge: +halfEdge,
      });
    } else {
      // It's a fully open exterior wall
      roomConnections[frontRoomIndexOnLevel].push({
        roomIndexOnLevel: undefined,
        connectionType: RoomConnectionType.OPEN_EXTERIOR,
        halfEdge: +halfEdge,
      });
    }
  }

  return roomConnections;
}
